import { AuthenticationRepository } from 'src/app/core/data/repository';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { ChangeUserNameAndPasswordForm } from '../../interface';
import { Repository } from './repository';
import { UserProfileApi } from '../api/user-profile-api';
import { JwtDecoderService } from '../../helper';

@Injectable({
  providedIn: 'root',
})
export class UserProfileRepository extends Repository {
  constructor(
    private userProfileApi: UserProfileApi,
    private authenticationRepository: AuthenticationRepository,
    private jwtDecoderService: JwtDecoderService
  ) {
    super();
  }

  changeUserNameAndPassword(form: ChangeUserNameAndPasswordForm): Observable<string> {
    return this.userProfileApi.changeUserNameAndPassword(form).pipe(
      tap((res) => {
        this.jwtDecoderService.saveToken(res);
        this.authenticationRepository.currentUser$.next(this.jwtDecoderService.getCurrentUserFromJWT());
      })
    );
  }
}
